
import './Schedule.scss'
import EmptyPage from '../../../../custom_components/EmptyPage'
import useUrlParams from '../../../../hooks/useUrlParams'
import useUrlNavigation from '../../../../hooks/useUrlNavigation'
import useScenario from '../../../../hooks/useScenario'
import { useMemo } from 'react'
import PlanningNavigation from '../PlanningNavigation'

const ControlSchedule = () => {
    const { scenario } = useScenario()
    const { tab_name,  } = useUrlParams()
    const { navigate_to } = useUrlNavigation()
    
    const deploymentType = useMemo(() => scenario?.scenarioDeploymentType, [scenario?.scenarioDeploymentType])

    return (
        <div className='planning__container__body'>
            <EmptyPage content='No Control Scheduled' >
                {deploymentType && (
                    <div className='planning__container__header'>
                        <PlanningNavigation deploymentType={deploymentType} activeTab={tab_name} onNavigate={navigate_to} />
                    </div>
                )}
            </EmptyPage>
        </div>
    )
}

export default ControlSchedule